const getters = {
  getJoinProcedures: (state) => state.joinProcedures,
  getJoinProcedure: (state) => state.joinProcedure,
};

export default getters;
